import { Vec3 } from "./vec3";
var Quaternion = (function () {
    function Quaternion(x, y, z, w) {
        if (x === void 0) { x = 0.0; }
        if (y === void 0) { y = 0.0; }
        if (z === void 0) { z = 0.0; }
        if (w === void 0) { w = 1.0; }
        this.v_ = new Vec3(x, y, z);
        this.w_ = w;
    }
    Object.defineProperty(Quaternion.prototype, "array", {
        get: function () {
            return [this.x, this.y, this.z, this.w];
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Quaternion.prototype, "w", {
        get: function () { return this.w_; },
        set: function (value) { this.w_ = value; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Quaternion.prototype, "x", {
        get: function () { return this.v_.x; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Quaternion.prototype, "y", {
        get: function () { return this.v_.y; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Quaternion.prototype, "z", {
        get: function () { return this.v_.z; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Quaternion.prototype, "v", {
        get: function () { return this.v_; },
        set: function (v) {
            this.v_.copy(v);
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Quaternion.prototype, "length", {
        get: function () {
            return Math.sqrt(Math.pow(this.x, 2) + Math.pow(this.y, 2) + Math.pow(this.z, 2) + Math.pow(this.w, 2));
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    ;
    ;
    Quaternion.fromAxisAngle = function (axis, angle) {
        if (axis === void 0) { axis = new Vec3(); }
        if (angle === void 0) { angle = 0.0; }
        var q = new Quaternion();
        var phi = angle / 2;
        q.v = axis.scale(Math.sin(phi));
        q.w = Math.cos(phi);
        return q;
    };
    ;
    Quaternion.fromArray = function (array) {
        var q = new Quaternion();
        q.v.x = array[0] || 0.0;
        q.v.y = array[1] || 0.0;
        q.v.z = array[2] || 0.0;
        q.w = array[3] || 1.0;
        return q;
    };
    ;
    Quaternion.fromAngleBetweenVectors = function (u, v, normalized) {
        if (normalized === void 0) { normalized = false; }
        var norm_u_norm_v = normalized ? 1.0 : Math.sqrt(u.squared_length * v.squared_length);
        var w = norm_u_norm_v + u.dot(v);
        var p;
        if (w < 1e-6 * norm_u_norm_v) {
            w = 0;
            p = u.orthogonal;
        }
        else {
            p = u.cross(v);
        }
        var q = new Quaternion(p.x, p.y, p.z, w);
        q.normalise();
        return q;
    };
    ;
    Quaternion.prototype.conjugate = function () {
        var c = new Quaternion();
        c.v = this.v_.scale(-1.0);
        c.w = this.w_;
        return c;
    };
    ;
    Quaternion.prototype.rotate = function (v) {
        var p = new Quaternion();
        p.w = 0.0;
        p.v = v.normalise();
        var q = this.multiply(p).multiply(this.conjugate());
        q.normalise();
        return q.v;
    };
    ;
    Quaternion.prototype.normalise = function () {
        var factor = 1.0 / this.length;
        this.v_.copy(this.v_.scale(factor));
        this.w_ *= factor;
    };
    Quaternion.prototype.multiply = function (q) {
        this.normalise();
        q.normalise();
        var r = new Quaternion();
        r.w = this.w_ * q.w - this.v_.dot(q.v);
        r.v = this.v_.scale(q.w).add(q.v.scale(this.w_)).add(this.v_.cross(q.v));
        return r;
    };
    ;
    Quaternion.prototype.copy = function (q) {
        this.v_.copy(q.v);
        this.w_ = q.w;
    };
    ;
    Quaternion.prototype.toString = function () {
        return "w: " + this.w + ", x: " + this.x + ", y: " + this.y + ", z: " + this.z;
    };
    ;
    return Quaternion;
}());
export { Quaternion };
//# sourceMappingURL=quaternion.js.map